import { PerformanceDatapoint } from 'owa-analytics';
import { SxSViewState, lazyResetPreviewPane } from 'owa-sxsdata';
export default async function fallbackOnOpenUrl(
    url: string,
    sxsViewState: SxSViewState,
    error: Error,
    datapoint: PerformanceDatapoint
) {
    const resetPreviewPane = await lazyResetPreviewPane.import();
    resetPreviewPane(sxsViewState);

    datapoint.addCustomProperty('PreviewFailure', error.stack.toString());

    window.open(url);
    datapoint.addCustomProperty('FallbackToOpenUrl', true);
    datapoint.end();
}
